import React, {useContext} from 'react';
import {merlinSurveyId} from "./utils/guideAssistantSteps/survey/surveyPageDemoSteps";

const defaultValue = {
  merlinSurveyId: merlinSurveyId,
  modalCloseBtn: <i className="fa fa-times-circle" role="img" aria-label="Close" />
};
const AppContext = React.createContext({});

const AppProvider = ({value, children}) => {
  return <AppContext.Provider value={value || defaultValue}>
    {children}
  </AppContext.Provider>;
}

const useAppContext = () => {
  return useContext(AppContext)
}

export {
  useAppContext,
  AppProvider
}
